// extracted by mini-css-extract-plugin
module.exports = {"container":"RightSidebar-module--container--32xfP"};